import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "a4-page",
  style: {"position":"relative","background-color":"var(--color-white)","border":"1px solid var(--color-light-gray)","box-shadow":"0 2px 8px rgba(0, 0, 0, 0.1)","width":"100%","aspect-ratio":"1/1.414","padding":"40px","overflow":"hidden"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_project_title_section = _resolveComponent("project-title-section")!
  const _component_project_info_section = _resolveComponent("project-info-section")!
  const _component_services_section = _resolveComponent("services-section")!
  const _component_installation_section = _resolveComponent("installation-section")!
  const _component_report_footer = _resolveComponent("report-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_project_title_section, {
      "project-data": _ctx.projectData,
      "include-sections": _ctx.includeSections,
      "report-type": _ctx.reportType
    }, null, 8, ["project-data", "include-sections", "report-type"]),
    (_ctx.includeSections.projectInfo)
      ? (_openBlock(), _createBlock(_component_project_info_section, {
          key: 0,
          "project-data": _ctx.projectData
        }, null, 8, ["project-data"]))
      : _createCommentVNode("", true),
    _createVNode(_component_services_section, { "report-type": _ctx.reportType }, null, 8, ["report-type"]),
    (_ctx.projectData?.service_type === 'complete_solution')
      ? (_openBlock(), _createBlock(_component_installation_section, {
          key: 1,
          "report-type": _ctx.reportType
        }, null, 8, ["report-type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_report_footer, { "report-type": _ctx.reportType }, null, 8, ["report-type"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "position-absolute bottom-0 end-0",
      style: {"padding":"20px 40px"}
    }, [
      _createElementVNode("small", {
        class: "text-muted",
        style: {"font-size":"12px"}
      }, "1")
    ], -1))
  ]))
}